"use client";
import React from "react";
import { Button } from "@/components/ui/button";
import { openInNewTab } from "@/lib/utils";

type Props = object;

function SomaHero({}: Props) {
  return (
    <section className="relative flex w-full items-center justify-center px-4 pt-20 md:px-6">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-1 items-center gap-12">
          <div className="text-center">
            {/* Main title with gradient effect and shimmer animation */}
            <h1 className="relative text-[clamp(2.5rem,1.5rem+4vw,5rem)] leading-[1.1] font-medium tracking-[-0.04em]">
              <span
                className="relative inline-block"
                style={{
                  background:
                    "linear-gradient(135deg, #FCFCFC 0%, #A0A0A0 50%, #505050 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Soma
                <span
                  className="pointer-events-none absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    backgroundClip: "text",
                    animation: "shimmer 3s ease-in-out infinite",
                  }}
                />
              </span>
            </h1>

            {/* Subtitle with subtle gradient */}
            <h2
              className="mt-2 text-[clamp(1.5rem,1rem+2vw,2.5rem)] leading-[1.2] font-medium tracking-[-0.02em]"
              style={{
                background:
                  "linear-gradient(135deg, #E0E0E0 0%, #B0B0B0 50%, #808080 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              AI Assistant for Developers on Discord
            </h2>

            {/* Description with enhanced styling */}
            <p className="mx-auto mt-4 max-w-lg text-lg leading-relaxed text-zinc-300">
              Ask Soma in any Discord channel or DM for instant help with code,
              bugs fixes or system design. It can search and read docs from a
              URL to give accurate answers.
            </p>

            {/* Enhanced button styling */}
            <div className="mt-8 flex flex-row items-center justify-center gap-4">
              <Button
                size="lg"
                className="group relative overflow-hidden rounded-lg border-0 bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg transition-all duration-300 hover:scale-105 hover:from-blue-500 hover:to-blue-600 hover:shadow-xl"
                onClick={() =>
                  openInNewTab(
                    "https://discord.com/oauth2/authorize?client_id=1425538042726191325"
                  )
                }
              >
                <span className="relative z-10">Add to Discord</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </Button>

              <Button
                variant="outline"
                className="group relative overflow-hidden rounded-lg border border-zinc-600 bg-transparent text-zinc-300 transition-all duration-300 hover:scale-105 hover:border-zinc-400 hover:bg-zinc-800/50 hover:text-white"
                onClick={() =>
                  openInNewTab("https://github.com/pasomadev/soma-app")
                }
                size="lg"
              >
                <span className="relative z-10">View on GitHub</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SomaHero;
